import React from 'react';
import { Flex, Box, theme, Modal, Text, Button } from '@xometry/xometry_loft';
import { css } from '@emotion/react';
import { Organization } from '../../../../schema/generated/schema';
import { WWW_ORIGIN } from '../../../../config';

export interface Props {
  newCreatedTeamModalOpen: boolean;
  setNewCreatedTeamModalOpen: (openState: boolean) => void;
  organization: Organization | undefined;
}

const NewCreatedTeamModal = ({
  newCreatedTeamModalOpen,
  setNewCreatedTeamModalOpen,
  organization,
}: Props) => {
  return (
    <>
      <div id="newCreatedTeamModal" />
      {newCreatedTeamModalOpen && (
        <Modal isOpen={newCreatedTeamModalOpen} breakpointMaxWidth="634px">
          <Box
            fontSize={theme.fontSizes[4]}
            textAlign="right"
            color={theme.colors.darkBlues[50]}
            onClick={() => {
              setNewCreatedTeamModalOpen(!newCreatedTeamModalOpen);
            }}
            css={css`
              &:hover {
                cursor: pointer;
              }
            `}
          >
            <i className="fa fa-times" />
          </Box>
          <Box margin="0px 24px 16px">
            <Flex marginBottom="24px" justifyContent="center">
              <img
                src="https://assets.xometry.com/Spot-Notifications-On.svg"
                alt="Notifications SVG"
              />
            </Flex>
            <Flex
              alignItems="center"
              flexDirection="column"
              marginBottom="32px"
            >
              <Text
                kind="page-title"
                color={theme.colors.darkBlues[90]}
                display="block"
                marginBottom="12px"
              >
                Welcome {organization?.name}!
              </Text>
              <Text>
                Congratulations, your team has been created and you will now
                have access to Teamspace! Any invited team members will have the
                Contributor role by default. Roles can be updated from your Team
                Settings page.
              </Text>
            </Flex>
            <Flex justifyContent="center">
              <Button
                kind={theme.kind.primaryOutline}
                marginRight={theme.space[2]}
                onClick={() =>
                  window.open(
                    `${WWW_ORIGIN}/refresh-tokens?domain=www&destination=/quoting/org/${organization?.id}`,
                    '_blank'
                  )
                }
              >
                Go To Teamspace
              </Button>
              <Button
                kind={theme.kind.primary}
                onClick={() => {
                  setNewCreatedTeamModalOpen(false);
                }}
              >
                Go To Team Management
              </Button>
            </Flex>
          </Box>
        </Modal>
      )}
    </>
  );
};

export default NewCreatedTeamModal;
